"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AvatarLink = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Link = _interopRequireDefault(require("../../Link"));

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      mediaQueries = _ref$theme.mediaQueries,
      hasMenuLinks = _ref.hasMenuLinks;
  return _ref2 = {
    backgroundColor: colors.white,
    color: colors.black,
    position: 'absolute',
    zIndex: '150',
    width: '20rem',
    top: '5.5rem',
    left: '-13rem'
  }, _defineProperty(_ref2, mediaQueries.small, {
    top: '6.4rem',
    left: '-12rem'
  }), _defineProperty(_ref2, '&::before', _defineProperty({
    content: hasMenuLinks ? '""' : 'none',
    position: 'absolute',
    left: '13.8rem',
    top: '-1.5rem',
    width: '0',
    height: '0',
    borderLeft: '1.2rem solid transparent',
    borderRight: '1.2rem solid transparent',
    borderBottom: "1.5rem solid ".concat(colors.white)
  }, mediaQueries.small, {
    left: '13.2rem'
  })), _ref2;
});
exports.Wrapper = Wrapper;
var AvatarLink = (0, _styled.default)(_Link.default)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      colors = _ref3$theme.colors;
  return {
    display: 'block',
    color: colors.black,
    padding: space.medium
  };
});
exports.AvatarLink = AvatarLink;